// src/lib/prerenderChunks.js
//
// Trasy jadą w osobnych paczkach JS (React.lazy). Webpack usuwa z DOM-u
// <script> doładowanej paczki, więc w zrzucie z prerenderu nie zostawał po
// niej ślad - przeglądarka użytkownika zaczynała ją pobierać dopiero po
// uruchomieniu main.js, a React w tym czasie czyścił prerenderowaną treść
// (fallback Suspense) i strona na moment znikała.
//
// Dlatego podczas prerenderu (headless Chrome) zapisujemy listę pobranych
// paczek w atrybucie <html data-prerender-chunks>. Skrypt prerenderujący
// zamienia ją na <link rel="preload" as="script"> i usuwa atrybut.

export const markPrerenderChunks = () => {
  if (typeof navigator === 'undefined' || !/HeadlessChrome/i.test(navigator.userAgent)) return;

  const collect = () => {
    const chunks = performance
      .getEntriesByType('resource')
      // initiatorType 'script' = paczka doładowana przez webpack.
      // Paczki z <link rel=prefetch> mają 'link' i celowo je pomijamy -
      // to zapas na później, nie treść tej strony.
      .filter(r => r.initiatorType === 'script' && /\/static\/js\/[^/]+\.chunk\.js$/.test(r.name))
      .map(r => new URL(r.name).pathname);

    if (chunks.length) {
      document.documentElement.setAttribute(
        'data-prerender-chunks',
        [...new Set(chunks)].join(',')
      );
    }
  };

  window.addEventListener('load', collect);
  // Paczka trasy potrafi dojechać już po zdarzeniu load.
  setTimeout(collect, 2500);
};
